module.exports = __webpack_public_path__ + "static/media/UAI-shield.c4bb00c2.png";